import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Wrapper from '@/views/Layouts/LayoutWrapper.vue';
import HomePage from '@/views/web/HomePage.vue';
import AccountPage from '@/views/web/AccountPage.vue';
import BlockPage from '@/views/web/BlockPage.vue';
import AssetPage from '@/views/web/AssetPage.vue';
import ChainPage from '@/views/web/ChainPage.vue';
import NftPage from '@/views/web/NftPage.vue';
import CounterpartyPage from '@/views/web/CounterpartyPage.vue';
import TransactionPage from '@/views/web/TransactionPage.vue';
import ResultsPage from '@/views/web/ResultsPage.vue';
import AllResultsPage from '@/views/web/AllResultsPage.vue';
import ResultsPageMobile from '@/views/mobile/ResultsPage.vue';
import AllResultsPageMobile from '@/views/mobile/AllResultsPage.vue';
import HomePageMobile from '@/views/mobile/HomePage.vue';
import AdminPageMobile from '@/views/mobile/AdminPage.vue';
import AdminPage from '@/views/web/AdminPage.vue';
import { isMobileScreen } from '@/helpers/common';
import store from '@/store';

function load(path: string) {
  return () => import(`@/views/${path}.vue`)
}

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: Wrapper,
    children: [
      { path: '/', redirect: '/home' },
      {
        path: '/admin',
        name: 'admin',
        component: async () => {
          return isMobileScreen() ? AdminPageMobile : AdminPage;
        },
        meta: {
          protected: false,
          layout: isMobileScreen() ? 'Admin' : 'Admin',
        },
      },
      {
        path: '/home',
        name: 'home',
        component: async () => {
          return isMobileScreen() ? HomePageMobile : HomePage;
        },
        meta: {
          protected: false,
          layout: isMobileScreen() ? 'Guest' : 'Guest',
        },
      },
      {
        path: '/results/byType/:type',
        name: 'resultsByType',
        component: async () => {
          return isMobileScreen() ? AllResultsPageMobile : AllResultsPage;
        },
        meta: {
          protected: false,
          layout: isMobileScreen() ? 'Mobile' : 'Web',
        },
      },
      {
        path: '/results',
        name: 'results',
        component: async () => {
          return isMobileScreen() ? ResultsPageMobile : ResultsPage;
        },
        meta: {
          protected: false,
          layout: isMobileScreen() ? 'Mobile' : 'Web',
        },
      },
      {
        path: '/chains/:chainNumber',
        name: 'chain',
        component: async () => {
          return isMobileScreen() ? ChainPage : ChainPage;
        },
        meta: {
          protected: false,
          layout: isMobileScreen() ? 'Mobile' : 'Web',
        },
      },
      {
        path: '/chains/:chainNumber/accounts/:address',
        name: 'account',
        component: async () => {
          return isMobileScreen() ? AccountPage : AccountPage;
        },
        meta: {
          protected: false,
          layout: isMobileScreen() ? 'Mobile' : 'Web',
        },
      },
      {
        path: '/chains/:chainNumber/blocks/:blockNumber',
        name: 'block',
        component: async () => {
          return isMobileScreen() ? BlockPage : BlockPage;
        },
        meta: {
          protected: false,
          layout: isMobileScreen() ? 'Mobile' : 'Web',
        },
      },
      {
        path: '/chains/:chainNumber/asset/:assetHash',
        name: 'asset',
        component: async () => {
          return isMobileScreen() ? AssetPage : AssetPage;
        },
        meta: {
          protected: false,
          layout: isMobileScreen() ? 'Mobile' : 'Web',
        },
      },
      {
        path: '/chains/:chainNumber/nft/:nftId',
        name: 'nft',
        component: async () => {
          return isMobileScreen() ? NftPage : NftPage;
        },
        meta: {
          protected: false,
          layout: isMobileScreen() ? 'Mobile' : 'Web',
        },
      },
      {
        path: '/chains/:chainNumber/counterparty/:counterpartyId',
        name: 'counterparty',
        component: async () => {
          return isMobileScreen() ? CounterpartyPage : CounterpartyPage;
        },
        meta: {
          protected: false,
          layout: isMobileScreen() ? 'Mobile' : 'Web',
        },
      },
      {
        path: '/chains/:chainNumber/transactions/:txRefhash',
        name: 'transaction',
        component: async () => {
          return isMobileScreen() ? TransactionPage : TransactionPage;
        },
        meta: {
          protected: false,
          layout: isMobileScreen() ? 'Mobile' : 'Web',
        },
      },
      {
        path: '/privacy-policy',
        name: 'privacy-policy',
        component: load('PrivacyPolicyPage'),
        meta: {
          protected: false,
          layout: isMobileScreen() ? 'Mobile' : 'Web',
        },
      },
      {
        path: '/:pathMatch(.*)*',
        name: 'page-not-found',
        component: load('PageNotFound'),
        meta: {
          notFound: true,
          protected: false,
        }
      }
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
        el: to.hash }
    } else {
      return { left: 0, top: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.protected && !store.getters.getIsLoggedIn) {
    next('/home');
  } else {
    next();
  }
});

export default router;
